export default __webpack_public_path__ + "static/media/ic_choose_by_url.1e402ae8.svg";